import { render } from "./list.vue?vue&type=template&id=df53be64"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"

import "./list.vue?vue&type=style&index=0&id=df53be64&lang=scss"

import exportComponent from "D:\\Workspace_git\\carrot\\pron_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__